/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "127b90d30c2dbfbeb527b4d75c40b039602d9627";
